
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-16553904\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"./src/styles\"],\"data\":\"@import \\\"./src/styles/common\\\";\",\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AboutUs.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AboutUs.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-16553904\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AboutUs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/AboutUs.vue
// module id = 1036
// module chunks = 1